import { render, staticRenderFns } from "./MessagePanelSingleInteraction.vue?vue&type=template&id=6e968ae2&scoped=true"
import script from "./MessagePanelSingleInteraction.vue?vue&type=script&lang=js"
export * from "./MessagePanelSingleInteraction.vue?vue&type=script&lang=js"
import style0 from "./MessagePanelSingleInteraction.vue?vue&type=style&index=0&id=6e968ae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e968ae2",
  null
  
)

export default component.exports